import ApplicationController from '../application_controller'
import { get } from '@rails/request.js'

class NextPageController extends ApplicationController {
  static targets = ['url', 'nextPage']

  urlTargetConnected() {
    const element = this.urlTarget

    this.waypoint = new Waypoint({
      element: element,
      offset: 'bottom-in-view',
      handler: async (direction) => {
        if (direction == 'down') {
          this.nextPageTarget.innerHTML = '<div class="loading"></div>'

          const response = await get(element.href)
          if (response.ok) {
            const html = await response.html
            this.nextPageTarget.innerHTML = html
          }
        }
      }
    })
  }

  urlTargetDisconnected() {
    this.waypoint.destroy()
  }
}

export default NextPageController
